module.exports = __webpack_public_path__ + "img/banking.ed99b318.svg";